import type { FileAttachment } from "@/types/file-attachment";

/** Convert a single File to a base64-encoded FileAttachment */
export async function fileToBase64(
  file: File,
): Promise<Required<FileAttachment>> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      // Strip the data URL prefix (e.g., "data:image/png;base64,")
      const base64 = dataUrl.split(",")[1] || dataUrl;
      resolve({
        name: file.name,
        type: file.type,
        size: file.size,
        data: base64,
      });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

/** Convert an array of Files to base64-encoded FileAttachments, skipping failures */
export async function filesToBase64(
  files: File[],
): Promise<Required<FileAttachment>[]> {
  const results: Required<FileAttachment>[] = [];
  for (const file of files) {
    try {
      const attachment = await fileToBase64(file);
      results.push(attachment);
    } catch (error) {
      console.error(`Failed to convert file ${file.name} to base64:`, error);
    }
  }
  return results;
}
